import { render } from "./ComponentHeader.vue?vue&type=template&id=c651aa34&scoped=true"
import script from "./ComponentHeader.vue?vue&type=script&lang=js"
export * from "./ComponentHeader.vue?vue&type=script&lang=js"

import "./ComponentHeader.vue?vue&type=style&index=0&id=c651aa34&scoped=true&lang=css"

import exportComponent from "/home/avatar_milano/avatar.web/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c651aa34"]])

export default __exports__